export default __webpack_public_path__ + "static/media/whiteCross.652e5c8c.svg";